/* eslint-disable */
/* eslint-disable no-underscore-dangle */ // Don't bother with dangling underscores in this file

/**
 * Create the initial state for the app
 * @returns {Object} The initial app state
 */
const createInitialState = () => {
  /* istanbul ignore if */
  if (typeof window.__INITIAL_STATE__ === `object` && window.__INITIAL_STATE__ !== null) {
    return window.__INITIAL_STATE__;
  }
  return {};
};

export default createInitialState;
